export {
  GovernTenantDto,
  CreateGovernTenantDto,
  UpdateGovernTenantDto,
  FindGovernTenantDto,
  GovernTenantFilters,
  GovernTenantState,
  SortOrderGovernTenantDto,
  GovernTenantResponseDto,
  OfflineTenantTranslation,
  OfflineTenantOwner,
} from "./tenant.dto";

export {
  FloorDto,
  CreateFloorDto,
  UpdateFloorDto,
  FindFloorDto,
} from "./floor.dto";

export { MallPublicDto } from "./mall-public.dto";

export {
  GovernTenantCategoryDto,
  FindGovernTenantCategoryDto,
  GovernTenantCategoryFormDto,
  GovernTenantCategoryFilters,
  GovernTenantCategoryState,
  TranslationItem,
  getDisplayString,
  getEn,
  getKh,
  ensureNameObject,
} from "./tenant-category.dto";

export {
  OfflineTenantVoucherDto,
  OfflineTenantVoucherMappingDto,
  CreateOfflineTenantVoucherDto,
  UpdateOfflineTenantVoucherDto,
  FindOfflineTenantVoucherDto,
  OfflineTenantVoucherCodeDto,
  NotificationTemplateDto,
  OfflineTenantVoucherStatsDto,
} from "./offline-tenant-voucher.dto";

export {
  TenantBookingDto,
  UpdateTenantBookingDto,
  TenantBookingFilters,
  TenantBookingState,
  OfflineTenantBookingTranslation,
  TenantBookingTimeSlotDto,
  TenantBookingImageDto,
  CreateSlotsDto,
  UpdateSlotStatusDto,
  TranslationObject,
} from "./tenant-booking.dto";

export {
  AdminManageQaDto,
  FindManageQaDto,
  CreateManageQaDto,
  UpdateManageQaDto,
} from "./manage-qa.dto";

export {
  MallFacilityDto,
  CreateMallFacilityDto,
  UpdateMallFacilityDto,
  FindMallFacilityDto,
  MallFacilityResponseDto,
  MallFacilityState,
  MallFacilityMall,
} from "./facility-booking.dto";

export {
  TableDto,
  CreateTableDto,
  UpdateTableDto,
  FindTableDto,
} from "./table.dto";

export {
  FnbOrderStatus,
  FnbOrderStatusType,
  FNB_ORDER_STATUS_TO_STRING,
} from "./fnb-order.dto";

// Stamp Collection (FR-01 → FR-09)
export {
  ChallengeStatus,
  ChallengeTimePhase,
  ChallengeLifecycleStatus,
  ChallengeCapabilitiesDto,
  ChallengeMallDto,
  ChallengeTenantOptionDto,
  ChallengeDto,
  FindChallengeDto,
  SaveChallengeDto,
} from "./challenge.dto";

export {
  MILESTONE_TYPE,
  MilestoneType,
  isOnlineTenantMilestone,
  isOfflineTenantMilestone,
  isPurchaseMilestone,
  isMallScopedMilestone,
  hasImplicitMallScope,
  createMilestoneScope,
  ChallengeMilestoneDto,
  MilestoneEventOptionDto,
  MilestoneQrDto,
  MilestoneDynamicQrDto,
} from "./challenge-milestone.dto";

export {
  REWARD_TYPE,
  RewardType,
  REWARD_DISCOUNT_TYPE,
  RewardDiscountType,
  REWARD_CODE_SOURCE,
  RewardCodeSource,
  ChallengeRewardCodeFileDto,
  ChallengeRewardPoolDto,
  UpdateRewardQuantityDto,
  ValidateRewardCodeImportDto,
  RewardCodeImportResultDto,
  ChallengeRewardOptionDto,
  ChallengeRewardTierDto,
} from "./challenge-reward.dto";

// Adapter i18n giữa `translations[]` của BE và `TranslationDto` của FE
export {
  ApiTranslationDto,
  API_LANGUAGE_CODES,
  toTranslation,
  localizedToTranslation,
  toApiTranslations,
  toApiDateTime,
  toBridgedStatus,
} from "./stamp-collection.mapper";

export {
  STAMP_REQUEST_STATUS,
  StampRequestStatus,
  StampRequestDto,
  StampRequestFileDto,
  StampRequestMilestoneOptionDto,
  FindStampRequestDto,
  RejectStampRequestDto,
} from "./stamp-request.dto";

export {
  STAMP_SOURCE_TYPE,
  StampSourceType,
  STAMP_RESULT_STATUS,
  StampResultStatus,
  StampHistorySummaryDto,
  StampHistoryItemDto,
  FindStampHistoryDto,
  ExportStampHistoryDto,
} from "./stamp-history.dto";

export {
  REWARD_CODE_STATUS,
  RewardCodeStatus,
  RewardHistorySummaryDto,
  RewardCodeDto,
  RewardHistoryItemDto,
  FindRewardHistoryDto,
  FindRewardCodeDto,
  ExportRewardHistoryDto,
  RewardOptionScopeDto,
} from "./reward-history.dto";

export { ChallengeConfigDto } from "./challenge-config.dto";